import { addFormatToken } from '../format-functions';
import { getMinutes } from '../utils/date-getters';
addFormatToken('m', ['mm', 2], null, function (date) {
    return getMinutes(date).toString(10);
});
//# sourceMappingURL=minute.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/units/minute.js
// module id = 823
// module chunks = 42